import { useMemo } from 'react'
import { useTar } from '@/modules'
import { Button, GoogleIcon } from '@duck/ui'

interface GoogleSignInButtonProps {
  onClick: () => void
  isDisabled: boolean
}

export const GoogleSignInButton = ({ onClick, isDisabled }: GoogleSignInButtonProps) => {
  const { t } = useTar()
  const isLastUsed = useMemo(() => window.localStorage.getItem('last_auth_provider') === 'google', [])

  return (
    <Button
      onClick={onClick}
      disabled={isDisabled}
      className={`group relative w-full flex items-center justify-center gap-3 px-4 py-3 border border-border rounded-lg 
               bg-card text-foreground transition-colors duration-200 focus:outline-none
               ${isDisabled
          ? 'opacity-50 cursor-not-allowed'
          : 'hover:bg-accent hover:text-white'
        }`}
    >
      <div className="flex items-center gap-3">
        <GoogleIcon size={20} className="w-5 h-5" />
        <span className="font-medium">{t('common.continueWithGoogle')}</span>
      </div>
      {isLastUsed && (
        <span className="absolute end-4 text-[10px] uppercase tracking-wide text-primary group-hover:text-accent-foreground">
          {t('auth.lastUsed')}
        </span>
      )}
    </Button>
  )
} 